import { message } from 'antd'
import { CargoApi } from '../../../api/Purchase/Cargo'
import { PackageApi } from '../../../api/Purchase/Package'
import CreateCargoModal from '../../../components/Purchasing/Packages/CreateCargoModal'
import Package from '../../../components/Purchasing/Packages/Package'
import PackageList from '../../../components/Purchasing/Packages/PackageList'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import useSelectionTable from '../../../elements/Hooks/useSelectionTable'
import useTitle from '../../../elements/Hooks/useTitle'
import { get, isEmpty, upperCase } from 'lodash'
import React from 'react'
import { withRouter } from 'react-router-dom'
import * as stringSimilarity from 'string-similarity'

function PackageCont (props) {
  useTitle('Package')

  const { delivery } = props

  const { list, fetching, fetch } = useFetchList(() =>
    delivery ? PackageApi.getLinesByDelivery(delivery._key) : PackageApi.list(),
  )

  // const list = unfilteredList.filter(p => p.locked !== true)
  const {
    tableRef,
    selection: selectionRaw,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()

  const similarityThreshold = 0.65
  const isStringSimilar = (a, b) => stringSimilarity.compareTwoStrings(upperCase(a), upperCase(b)) > similarityThreshold
  const selectionData = selectionRaw.map((s) => list.find((p) => get(p, '_id') === s))
  const selection =
    selectionRaw.length === 0
      ? list
      : list.filter((v) => {
        /**
         * if it's have no current location that mean it's a starting point,
         * which it may have different address but same location code.
         * So if it's Start we filter based on address label
         * if not we filter based on location code
         */
        const isFirstStart = isEmpty(get(selectionData, '[0]currentLocation'))
        const sameStartAddress = isStringSimilar(
          get(v, 'from.address.label'),
          get(selectionData, '[0]from.address.label'),
        )
        const isNotLocked = v.locked !== true
        const sameLocation = isStringSimilar(get(v, 'from.location'), get(selectionData, '[0]from.location'))
        const notStart = !isEmpty(get(v, 'currentLocation'))
        const sameAddress = isFirstStart ? sameStartAddress : sameLocation && notStart
        return sameAddress && isNotLocked
      })

  const {
    visible,
    modalType,
    object: cargo,
    setObject: setCargo,
    submitting,
    checkForm,
    formRef,
    onShow,
    onCancel,
    setSubmitting,
    isNew,
  } = useModalData()

  async function submit () {
    let newObject = await checkForm()
    newObject.packages = selectionRaw
    setSubmitting(true)
    try {
      const data = await CargoApi.create(newObject)
      props.history.replace({
        pathname: `/purchasing/cargo/${data._key}/update`,
      })
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || e)
    }
    setSubmitting(false)
  }

  const passProps = {
    list,
    fetching,
    fetch,
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    selectionData,
    selectionRaw,
    toggleAll,
    isSelected,
    visible,
    modalType,
    cargo,
    setCargo,
    submitting,
    checkForm,
    formRef,
    onShow,
    onCancel,
    setSubmitting,
    isNew,
    submit,
  }

  return delivery ? (
    <>
      <CreateCargoModal {...passProps} />
      <PackageList {...passProps} />
    </>
  ) : (
    <Package {...passProps} />
  )
}

PackageCont.propTypes = {}
PackageCont.defaultProps = {}

export default withRouter(PackageCont)
